export default __webpack_public_path__ + "static/media/whatsapp.42f2f941.svg";